import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class CuGroupService extends ApiService {

    index(params: any = {}) {
        return super.get('/cu-groups', params);
    }

    store(body: any) {
        return super.post('/cu-groups', body);
    }

    edit(cuGroupId: number) {
        return super.get(`/cu-groups/${cuGroupId}/edit`);
    }

    update(cuGroupId: number, body: any) {
        return super.put(`/cu-groups/${cuGroupId}`, body);
    }

    destroy(cuGroupId: number) {
        return super.delete(`/cu-groups/${cuGroupId}`);
    }

    select(params: any = {}) {
        return super.get('/cu-groups/select', params);
    }
}
